import React from 'react';
import styled from 'styled-components';
import { FormattedMessage, defineMessages } from 'react-intl';

import Anchor from '../main/utils/Anchor';
import { PRESS_QUOTES } from '../main/reviews/PressQuotes';
import { Dots, SlideCarousel, slickFill } from './shared';
import { media } from '../../styles/style-utils';
import { type } from '../../styles/typography';
import portrait from '../../assets/images/home/testimonial-portrait.jpg';

const messages = defineMessages({
  quote: {
    id: 'reviews.featured.quote',
    defaultMessage:
      '“I adore IDAGIO. It’s easy to use and it brings classical music to people around the world. I’m so happy to share this ingenious platform with my fans.”',
  },
  role: { id: 'reviews.featured.role', defaultMessage: 'Pianist' },
});

const SLIDES = [
  {
    id: 'yuja-wang',
    name: 'Yuja Wang',
    quote: messages.quote,
    role: messages.role,
  },
  ...PRESS_QUOTES.map(({ source, quote }) => ({
    id: source,
    name: source,
    quote,
  })),
];

const Wrapper = styled.section`
  position: relative;
  background-color: var(--b-white);
  color: var(--b-black);

  ${media.large`
    height: 866px;
  `};
`;

const Stage = styled.div`
  position: relative;
  height: 420px;
  overflow: hidden;
  background: #3c2924 url(${portrait}) 90% 12% / 111% auto no-repeat;

  ${media.large`
    width: 1052px;
    max-width: 75%;
    height: 731px;
  `};
`;

const QuoteBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background-color: var(--b-lilac);

  ${slickFill};

  ${media.large`
    position: absolute;
    top: 0;
    right: 0;
    width: 50vw;
    height: 408px;
  `};
`;

const Quote = styled.blockquote`
  gap: 32px;
  margin: 0;
  padding: 32px var(--b-gutter);

  ${media.large`
    padding: 44px 43px 42px;
  `};

  p {
    ${type('title', 'large')};
    max-width: 70%;
    margin: 0;
    color: var(--b-black);
  }

  footer {
    display: flex;
    flex-direction: column;
    gap: 1px;
    margin-top: auto;
    padding-right: 66px;

    cite {
      ${type('label', 'medium', { emphasis: true })};
      font-style: normal;
    }

    span {
      ${type('label', 'small', { uppercase: true })};
      color: rgba(0, 0, 0, 0.6);
    }
  }
`;

const DotsSlot = styled.div`
  position: absolute;
  right: var(--b-gutter);
  bottom: 32px;
  z-index: 1;

  ${media.large`
    right: 43px;
    bottom: 42px;
  `};
`;

const Testimonial = () => (
  <Wrapper>
    <Anchor id="reviews" />
    <Stage role="img" aria-label="Yuja Wang" />
    <QuoteBox>
      <SlideCarousel
        renderDots={(active, select) => (
          <DotsSlot>
            <Dots count={SLIDES.length} active={active} onSelect={select} label="Testimonials" />
          </DotsSlot>
        )}
      >
        {SLIDES.map(slide => (
          <Quote key={slide.id} className="slide">
            <p>
              <FormattedMessage {...slide.quote} />
            </p>
            <footer>
              <cite>{slide.name}</cite>
              {slide.role && (
                <span>
                  <FormattedMessage {...slide.role} />
                </span>
              )}
            </footer>
          </Quote>
        ))}
      </SlideCarousel>
    </QuoteBox>
  </Wrapper>
);

export default Testimonial;



// WEBPACK FOOTER //
// /tmp/build_2cb81483/src/components/home/Testimonial.js